// import { sendInvite } from "@/api";

import {
  sendInvite,
  listInvites,
  registerInvitation,
  sendImagem,
  sendGuests,
  getByInvite,
  getEdit,
  deleteInvite,
} from "@/api";
import router from "@/router";
import { i18n } from "../../main";

const state = {
  inviteEvent: null,
  saveId: {},
  sendInviteEvent: null,
  sendGuestEvent: null,
  listCreatedInvitations: null,
  inviteCardsLoading: false,
  AddGuests: false,
  inviteRegister: null,
  typeInvite: "",
  emailsOptions: [],
  images: {},
  infoRegister: {},
  setInfoRegister: {},
  inviteSetImage: [],
  statusTab: false,
};
const getters = {
  statusTab: state => state.statusTab,
  getInfoRegister: state => state.infoRegister,
  getImage: state => state.images,
  inviteImages: state => state.inviteSetImage,
  saveId: state => state.saveId,
  getTypeInvite: state => state.typeInvite,
  inviteEvent: state => state.inviteEvent,
  sendInviteEvent: state => state.sendInviteEvent,
  sendGuestEvent: state => state.sendGuestEvent,
  inviteRegister: state => state.inviteRegister,
  listCreatedInvitations: state => state.listCreatedInvitations,
  inviteCardsLoading: state => state.inviteCardsLoading,
  AddGuests: state => state.AddGuests,
  emailsOptions: state => state.emailsOptions,
};

const actions = {
  async deleteInvite({ commit }, params) {
    try {
      await deleteInvite(params);
      this._vm.$toast(i18n.t("marketing.invitation.send-invitations-success"), {
        type: "success",
      });
      commit("fetchInviteEvent");
    } catch (error) {
      console.log(error);
      this._vm.$toast(i18n.t("marketing.invitation.delete-invitation-error"), {
        type: "error",
      });
    }
  },
  async setEdit({ commit }, idemail_marketing) {
    try {
      const response = await getByInvite(idemail_marketing);
      const infoRegister = {
        idloja: response.data.idloja,
        idemail_marketing: response.data.idemail_marketing,
        email_evento: response.data.email_evento,
        nome: response.data.nome,
        corpo: response.data.corpo,
        nome_evento: response.data.nome_evento,
        data_evento: response.data.data_evento,
        organizador: response.data.organizador,
        local_evento: response.data.local_evento,
        link: response.data.link,
        importa_dados: response.data.importa_dados,
        dthr_aceite_termo: response.data.dthr_aceite_termo,
        loja: response.data.loja,
        assunto: response.data.assunto,
        remetente: response.data.remetente,
        qtd_enviada: response.data.qtd_enviada,
        status: response.data.status,
        finalizado: response.data.finalizado,
        idproduto: response.data.idproduto,
        anexos: response.data.anexos,
      };
      commit("setInfo", {
        infoRegister,
      });
    } catch (error) {
      console.log(error);
    }
  },
  // eslint-disable-next-line no-unused-vars
  setOpenAddGuests({ commit, dispatch }) {
    commit("guestsAdd");
    dispatch("setSaveId");
  },

  setSaveId({ commit }, saveId) {
    commit("setSaveId", saveId);
  },

  fetchInviteEvent({ commit }, params) {
    commit("setinviteCardsLoading", true);
    listInvites(params).then(response => {
      commit("setInviteEvent", response.data);
      commit("setinviteCardsLoading", false);
    });
  },

  async uploadImage({ commit }, images, params) {
    commit("setUploading", true);
    try {
      const response = await sendImagem(images, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      commit("setUploading", false);
      commit("inviteImage", response.data.url);
      return response.data.url;
    } catch (error) {
      console.log(error);
      commit("setUploading", false);
    }
  },

  async setSendInvite({ commit }, params) {
    try {
      await sendInvite(params).then(response => {
        commit("setSendInvite", response.data);
        this.testeForm = "sucesso";
        this._vm.$toast(
          i18n.t("marketing.invitation.send-test-email-success"),
          {
            type: "success",
          }
        );
      });
    } catch (error) {
      this._vm.$toast(i18n.t("marketing.invitation.send-test-email-error"), {
        type: "error",
      });
    }
  },

  async setSendGuest({ commit }, params) {
    try {
      await sendGuests(params).then(response => {
        commit("setSendGuest", response.data);
        this._vm.$toast(
          i18n.t("marketing.invitation.send-invitations-success"),
          {
            type: "success",
          }
        );
        commit("guestsAdd");
      });
    } catch (error) {
      console.log(error);
      this._vm.$toast(i18n.t("marketing.invitation.send-invitations-error"), {
        type: "error",
      });
    }
  },

  async setRegisterInvitation({ commit }, params) {
    try {
      await registerInvitation(params).then(response => {
        commit("setRegisterInvitation", response.data);
        commit("fetchInviteEvent");
        commit("setTab", true);
        this._vm.$toast(
          i18n.t("marketing.invitation.save-as-template-success"),
          {
            type: "success",
          }
        );
      });
    } catch (error) {
      this._vm.$toast(i18n.t("marketing.invitation.save-as-template-error"), {
        type: "error",
      });
    }
  },

  // eslint-disable-next-line no-unused-vars
  async setEditInvitation({ commit }, params) {
    try {
      await getEdit(params);
      this._vm.$toast(i18n.t("marketing.invitation.edit-template-success"), {
        type: "success",
      });
      router.push(`/marketing/convite`);
      commit("setTab", true);
    } catch (error) {
      console.log("error");
      this._vm.$toast(i18n.t("marketing.invitation.edit-template-error"), {
        type: "error",
      });
    }
  },

  setRoute({ commit }, route) {
    commit("setRoute", route);
  },

  setTypeInvite({ commit }, type) {
    commit("setTypeInvite", type);
  },
};

const mutations = {
  setTab(state, statusTab) {
    state.statusTab = statusTab;
  },
  setImage(state, data) {
    const imageTransformed = data.reduce((acc, item) => {
      acc[item.type] = item.src;
      return acc;
    }, {});
    const jsonImg = JSON.stringify(imageTransformed);
    state.images = { anexos: jsonImg };
  },
  inviteImage(state, images) {
    state.inviteSetImage = [...state.inviteSetImage, images];
  },
  setInfo(state, data) {
    state.infoRegister = data.infoRegister;
    state.images = data.imageTransformed;
  },
  setSaveId(state, saveId) {
    state.saveId = saveId;
  },
  setEmails(state, emailsOptions) {
    state.emailsOptions = emailsOptions;
  },
  setTypeInvite(state, type) {
    state.typeInvite = type;
  },
  setInviteEvent(state, event) {
    state.inviteEvent = event || "";
  },

  setSendInvite(state, sendInviteEvent) {
    state.sendInviteEvent = sendInviteEvent;
  },

  setSendGuest(state, sendGuestEvent) {
    state.sendGuestEvent = sendGuestEvent;
  },

  setRegisterInvitation(state, inviteRegister) {
    state.inviteRegister = inviteRegister;
  },

  setinviteCardsLoading(state, bool) {
    state.inviteCardsLoading = bool;
  },
  guestsAdd: state => (state.AddGuests = !state.AddGuests),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
